import classNames from 'classnames';
import { type CSSProperties } from 'react';

import { getAbSetting } from "@/helpers/abTesting.ts";

import styles from './index.module.scss';

interface ListProps<Values extends string[]> {
    values: Values
    onClick: (value: Values[number]) => void
    checkFn: (value: Values[number]) => boolean
    perRow?: number
}

export default function List<Values extends string[]> ({
    values,
    onClick,
    checkFn,
    perRow = 3
}: ListProps<Values>) {

    const isOverlapping = values.length % perRow !== 0;

    return (
        <div className={classNames(styles.list, {
            [styles.overlapping]: isOverlapping,
        })} style={{ '--perRow': perRow } as CSSProperties}>
            {values.map((value) => (
                <div
                    key={value}
                    className={classNames(styles.listItem, {
                        [styles.active]: checkFn(value),
                    })}
                    onClick={() => onClick(value)}
                >
                    {value}
                </div>
            ))}
        </div>
    );
}
